import type { RouteRecordRaw } from 'vue-router'

export const volunteerRoutes: RouteRecordRaw[] = [
  {
    path: '/volunteer',
    name: routeNames.volunteer,
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: {
      requiresAuth: true,
      role: 'volunteer'
    },
    children: [
      {
        path: 'requests',
        name: routeNames.volunteerRequests,
        component: () => import('@/components/AppRouterView.vue'),
        redirect: { name: routeNames.volunteerAvailableRequests },
        children: [
          {
            path: 'available',
            name: routeNames.volunteerAvailableRequests,
            component: () => import('@/views/volunteer/requests/VolunteerAvailableRequests.vue')
          },
          {
            path: 'my',
            name: routeNames.volunteerMyRequests,
            component: () => import('@/views/volunteer/requests/VolunteerMyRequests.vue')
          },
          {
            path: ':id',
            name: routeNames.volunteerRequestDetail,
            component: () => import('@/views/volunteer/requests/VolunteerRequestDetail.vue')
          }
        ]
      },
      {
        path: 'profile',
        name: routeNames.volunteerProfile,
        component: () => import('@/views/volunteer/VolunteerProfile.vue')
      }
    ]
  },

  {
    path: '/volunteer/profile',
    component: () => import('@/layouts/FormLayout.vue'),
    meta: {
      requiresAuth: true,
      role: 'volunteer',
      backToLink: routeNames.volunteerProfile
    },
    children: [
      {
        path: 'info',
        name: routeNames.volunteerProfileInfo,
        component: () => import('@/views/volunteer/profile/VolunteerProfileInfo.vue')
      },
      {
        path: 'phone',
        name: routeNames.volunteerProfilePhone,
        component: () => import('@/views/profile/ProfilePhone.vue'),
        meta: {
          successRedirect: routeNames.volunteerProfile
        }
      }
    ]
  }
]
